// import { createAsyncThunk } from "@reduxjs/toolkit";

// import { iAddProFormInvoiceDetail ,iGenericResponse,REDUCER_NAME} from "./Types";

// import { httpStatusCodes } from "@/customTypes/NetworkTypes";
//  import { saleReportDataList } from "@/services/api/cresivoxServer";
// import { curryGetThunkName } from "@/projectUtils/ReduxUtil";
// const curriedGetThunkName = curryGetThunkName(REDUCER_NAME);
// interface PurchaseOrderPayload {
//   vendorId: string;
//   amount: string;
// }
// export const getSaleReportData = createAsyncThunk<
// // @ts-expect-error
//   iGenericResponse<iProductReportResponse>, 
//   void,
//   { rejectValue: { message: string } }
// >(
//   curriedGetThunkName("getSaleReportData"),

//   async (_, { rejectWithValue }) => {
//     try {
//       const response = await saleReportDataList.getSaleReportData();

//       if (!response) {
//         return rejectWithValue({ message: "No response received" });
//       }

//       const { httpStatusCode, data, message } = response;

//       if (httpStatusCode === httpStatusCodes.SUCCESS_OK) {
//         if (data && data.data) {
//           console.log("✅ Overview Chart Data:", data.data);

//           return {
//             httpStatusCode,
//             data: { overviewChart: data.data }, // 👈 return correctly typed object
//             message,
//           };
//         } else {
//           return rejectWithValue({ message: "overviewChart not found in response" });
//         }
//       }

//       return rejectWithValue({ message });
//     } catch (error) {
//       console.log("🚀 ~ error:", error);
//       return rejectWithValue({ message: "Something went wrong" });
//     }
//   }
// );


import { createAsyncThunk } from "@reduxjs/toolkit";
import { iGenericResponse, REDUCER_NAME } from "./Types";
import { httpStatusCodes } from "@/customTypes/NetworkTypes";
import { saleReportDataList } from "@/services/api/cresivoxServer";
import { curryGetThunkName } from "@/projectUtils/ReduxUtil";
import { iProductReportResponse } from "@/redux/productReportData/Types";

const curriedGetThunkName = curryGetThunkName(REDUCER_NAME);

// ✅ Accept query params dynamically from component
interface iSaleReportParams {
  startDate?: string;
  endDate?: string;
  customer?: string;
  productId?: string;
}

export const getSaleReportData = createAsyncThunk<
// @ts-expect-error
  iGenericResponse<iProductReportResponse>,
  iSaleReportParams, // 👈 accepts params now
  { rejectValue: { message: string } }
>(
  curriedGetThunkName("getSaleReportData"),
  async (params, { rejectWithValue }) => {
    try {
      // 👇 Pass params to the service call
      const response = await saleReportDataList.getSaleReportData(params);

      if (!response) {
        return rejectWithValue({ message: "No response received" });
      }

      const { httpStatusCode, data, message } = response;

      if (httpStatusCode === httpStatusCodes.SUCCESS_OK) {
        if (data && data.data) {
          return {
            httpStatusCode,
            data: { overviewChart: data.data },
            message,
          };
        } else {
          return rejectWithValue({ message: "overviewChart not found in response" });
        }
      }

      return rejectWithValue({ message });
    } catch (error) {
      console.error("🚀 ~ getSaleReportData error:", error);
      return rejectWithValue({ message: "Something went wrong" });
    }
  }
);
